module.exports = __webpack_public_path__ + "img/banner_activity_2.86207bac.png";